import React from 'react';
import { generateGridStyles } from '../components/helpers';

const Notifications = ({ getHandlers, val, gridStyles, name }) => {
    const { stylers, classes } = generateGridStyles(gridStyles, name);
    if (!val) return null;
    let type = 'SMS';
    if (val.startsWith('@') === true) {
        type = 'telegram';
    }
    if (!val.startsWith('@') && val.includes('@')) {
        type = 'E-mail';
    }
    return (
        <div {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
            <p>{val}</p>
            <div
                style={{
                    marginTop: '5px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '60px',
                    height: '24px',
                    backgroundColor: 'var(--greyExtraDarkColorTransparent)',
                    padding: '5px 8px',
                    color: 'var(--greySuperDarkColor)',
                    borderRadius: '6px',
                    whiteSpace: 'nowrap'
                }}
            >
                <p>{type}</p>
            </div>
        </div>
    );
};
export default Notifications;
